module.exports = __webpack_public_path__ + "static/media/push-and-pull.1bd0efc2.jpg";